module.exports = __webpack_public_path__ + "static/media/baseMeme3thumb.0497b268.jpg";